import { combineReducers } from 'redux';
import { appReducer } from './app/app/reducers';
import authReducer from './authentication/reducers';
import { headerSearchReducer } from './headerSearch/reducers';
import { readMessageReducer } from './message/reducers';
import messagesReducer from './messages/reducers';
import { readNotificationReducer } from './notification/reducers';
import ChangeLayoutMode from './themeLayout/reducers';
import usersReducer from './users/reducers';


const rootReducers = combineReducers({
  headerSearchData: headerSearchReducer,
  message: readMessageReducer,
  notification: readNotificationReducer,
  users: usersReducer,
  auth: authReducer,
  ChangeLayoutMode,
  messages: messagesReducer,
  app: appReducer
});

export default rootReducers;
